export default class LoggingService {
  constructor(userMonitor, locale) {
    this.userMonitor = userMonitor;
    this.locale = locale;
  }

  logMoreSurveysButton(pageType) {
    this.userMonitor.addAction("More Surveys", {
      locale: this.locale,
      pageType: pageType,
    });
  }

  logEndPageLoad(pageType) {
    this.userMonitor.addAction("End Page", {
      locale: this.locale,
      pageType: pageType,
    });
  }
}
